export default __webpack_public_path__ + "static/media/pause.d143e1ba.svg";